import React from "react";
import classNames from "classnames";
import PropTypes from "prop-types";
import { Interactive } from "react-interactive";
import { CSSTransition } from "react-transition-group";
import SVGIcon from "~components/utils/svg_icon/svg_icon";
import useHandleInteractiveStateChange from "~hooks/use_handle_interactive_state_change/use_handle_interactive_state_change";
import * as transitionSlideHorizFadeScale from "../../../../../styles/global_scss_modules/global_css_transition_styles/transition_slide_horiz_fade_scale.module.scss";
import {
  buttonWrapperStyle,
  isActiveStyle,
  textStyle,
} from "./toc_icon_button.module.scss";

const transitionClassnames = { ...transitionSlideHorizFadeScale };

const TRANSITION_TIMEOUT = {
  appear: 200,
  enter: 200,
  exit: 200,
};
function TOCIconButton({
  title,
  isNavExpanded,
  onClick,
  icon,
  isSmall,
  isReversed,
}) {
  const [isActive, handleInteractiveStateChange] =
    useHandleInteractiveStateChange();

  const buttonWrapperClassNames = classNames(buttonWrapperStyle, {
    [isActiveStyle]: isActive,
    [isReversed]: isReversed,
  });
  const textClassNames = classNames(textStyle, {
    [isActiveStyle]: isActive,
  });

  const iconSize = isSmall ? 20 : 32;

  return (
    <Interactive
      as="button"
      onClick={onClick}
      className={buttonWrapperClassNames}
      onStateChange={handleInteractiveStateChange}
    >
      <SVGIcon
        icon={icon}
        isActive={isActive}
        width={iconSize}
        height={iconSize}
      />
      <CSSTransition
        key={title}
        timeout={TRANSITION_TIMEOUT}
        classNames={transitionClassnames}
        appear
        unmountOnExit
        in={isNavExpanded}
      >
        <div className={textClassNames}>{title}</div>
      </CSSTransition>
    </Interactive>
  );
}

TOCIconButton.propTypes = {
  icon: PropTypes.string,
  isNavExpanded: PropTypes.bool,
  isSmall: PropTypes.bool,
  onClick: PropTypes.func,
  title: PropTypes.string.isRequired,
  isReversed: PropTypes.bool,
};

TOCIconButton.defaultProps = {
  icon: "icon_chapters",
  isSmall: false,
  isNavExpanded: false,
  isReversed: false,
  onClick: () => {},
};

export default TOCIconButton;
